import React, { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

type CreditsTableData = { name: string; free: number; starter: number; professional: number; team: number };
const creditsTableData: CreditsTableData[] = [
  { name: 'Flux Fast', free: 375, starter: 3750, professional: 10000, team: 11250 },
  { name: 'Flux 2 Pro', free: 30, starter: 300, professional: 800, team: 900 },
  { name: 'Nano Banana 2', free: 25, starter: 251, professional: 667, team: 751 },
  { name: 'Nano Banana Pro', free: 13, starter: 133, professional: 356, team: 400 },
  { name: 'GPT Image 1.5', free: 21, starter: 214, professional: 571, team: 643 },
  { name: 'Seedream V5', free: 38, starter: 375, professional: 1000, team: 1125 },
  { name: 'Recraft V4', free: 17, starter: 167, professional: 444, team: 500 },
  { name: 'Mystic', free: 13, starter: 125, professional: 333, team: 375 },
  { name: 'Qwen Multiangle', free: 38, starter: 375, professional: 1000, team: 1125 },
  { name: 'Topaz Upscale', free: 8, starter: 79, professional: 211, team: 237 },
  { name: 'Kling 3', free: 1, starter: 15, professional: 40, team: 45 },
  { name: 'Kling Motion Control', free: 1, starter: 10, professional: 27, team: 30 },
  { name: 'Kling O1', free: 1, starter: 14, professional: 36, team: 41 },
  { name: 'Veo 3.1', free: 1, starter: 17, professional: 44, team: 51 },
  { name: 'Seedance 1.5', free: 5, starter: 48, professional: 129, team: 145 },
  { name: 'Runway Gen-4.5', free: 2, starter: 21, professional: 57, team: 64 },
  { name: 'Grok Imagine', free: 4, starter: 42, professional: 111, team: 125 },
  { name: 'Wan 2.5', free: 3, starter: 27, professional: 73, team: 82 },
  { name: 'Wan Animate', free: 1, starter: 15, professional: 40, team: 45 },
  { name: 'Luma Ray 2', free: 1, starter: 14, professional: 37, team: 42 },
  { name: 'LTX 2', free: 2, starter: 15, professional: 40, team: 45 },
  { name: 'Hunyuan 3D V3', free: 1, starter: 19, professional: 50, team: 56 },
  { name: 'Rodin V2', free: 4, starter: 42, professional: 111, team: 125 },
];

const StyledTable = styled(Table)({ backgroundColor: 'transparent' });

const StyledTableHead = styled(TableHead)({ backgroundColor: 'transparent' });

const StyledTableBody = styled(TableBody)({ backgroundColor: 'transparent' });

const StyledHeaderTableCell = styled(TableCell)({
  color: 'white',
  borderBottom: 'none',
  backgroundColor: 'transparent',
  textAlign: 'center',
  fontWeight: '600',
  fontFamily: 'DM Sans',
  fontSize: '14px',
});
const StyledCreditsTableCell = styled(TableCell)({
  borderBottom: 'none',
  backgroundColor: 'transparent',
  textAlign: 'center',
  fontWeight: '400',
  fontFamily: 'DM Sans',
  fontSize: '14px',
  color: 'rgba(255, 255, 255, 0.8)',
});
const StyledServiceTableCell = styled(TableCell)({
  borderBottom: 'none',
  backgroundColor: 'transparent',
  textAlign: 'left',
  fontWeight: '400',
  fontFamily: 'DM Sans',
  fontSize: '14px',
  color: 'rgba(255, 255, 255, 0.8)',
  paddingLeft: '0px',
});

function CreditsTable({ maxWidth }) {
  const [data, setData] = useState<CreditsTableData[]>([]);

  useEffect(() => {
    setData(creditsTableData);
  }, []);

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <TableContainer
        component={Paper}
        sx={{ backgroundColor: 'transparent', boxShadow: 'none', maxWidth: maxWidth, backgroundImage: 'none' }}
      >
        <StyledTable>
          <StyledTableHead>
            <TableRow>
              <StyledHeaderTableCell></StyledHeaderTableCell>
              <StyledHeaderTableCell align="right">Free</StyledHeaderTableCell>
              <StyledHeaderTableCell align="right">Starter</StyledHeaderTableCell>
              <StyledHeaderTableCell align="right">Professional</StyledHeaderTableCell>
              <StyledHeaderTableCell align="right">Team</StyledHeaderTableCell>
            </TableRow>
          </StyledTableHead>
          <StyledTableBody>
            {data.map((row) => (
              <TableRow key={row.name}>
                <StyledServiceTableCell component="th" scope="row">
                  {row.name}
                </StyledServiceTableCell>
                <StyledCreditsTableCell align="right">{row.free}</StyledCreditsTableCell>
                <StyledCreditsTableCell align="right">{row.starter}</StyledCreditsTableCell>
                <StyledCreditsTableCell align="right">{row.professional}</StyledCreditsTableCell>
                <StyledCreditsTableCell align="right">{row.team}</StyledCreditsTableCell>
              </TableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </TableContainer>
    </Box>
  );
}

export default CreditsTable;
